import { Icon } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import type { ErrorChatMessage } from '../types';
import { errorMessageCss, errorMessageIconCss } from './ErrorMessage.styles';

interface ErrorMessageProps {
  message: ErrorChatMessage;
}

/** Renders an error message aligned to the left of the conversation. */
export const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => (
  <div className={errorMessageCss}>
    <Icon name="error" size={20} className={errorMessageIconCss} />
    {message.content}
  </div>
);

ErrorMessage.displayName = 'ErrorMessage';
